import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const PushLine24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9999 6C19.1045 6 19.9999 5.10457 19.9999 4C19.9999 2.89543 19.1045 2 17.9999 2C16.8954 2 15.9999 2.89543 15.9999 4C15.9999 5.10457 16.8954 6 17.9999 6ZM17.9999 8C18.4404 8 18.8499 8.32548 18.8499 8.7659V18C18.8499 20.1263 17.1262 21.85 14.9999 21.85H8.9999C6.87361 21.85 5.1499 20.1263 5.1499 18V6C5.1499 3.8737 6.87361 2.15 8.9999 2.15H13.333C13.8424 2.15 14.1848 2.69035 14.0821 3.18932C14.0086 3.54663 13.7139 3.85 13.3491 3.85H8.9999C7.81249 3.85 6.8499 4.81259 6.8499 6V15.65C6.8499 16.2023 7.29762 16.65 7.8499 16.65H16.1499C16.7022 16.65 17.1499 16.2023 17.1499 15.65V8.76595C17.1499 8.32549 17.5595 8 17.9999 8ZM8.9999 20.15C8.3486 20.15 7.76493 19.8604 7.37066 19.4029C6.96799 18.9357 7.4385 18.35 8.05528 18.35H15.9445C16.5613 18.35 17.0318 18.9357 16.6291 19.4029C16.2349 19.8604 15.6512 20.15 14.9999 20.15H8.9999Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
